module.exports = __webpack_public_path__ + "img/video-8.ff3706a2.png";